import React from 'react';
import { ButtonBuilder } from '../../../../../../../../GlobalComponents/Builders';
import { CheckSquare } from 'react-feather';

/**
 * Bulk-edit control cluster shared by the DMT mapping sections.
 *
 * Off: a compact icon toggle. On: the toggle (filled) + a bordered pill holding a select-all checkbox,
 * the live count, and the caller's "Edit (N)" modal button.
 *
 * The edit modal differs per section (fields, endpoint), so it's passed in as `editModal` rather than built here.
 */
const BulkEditControls = ({
    bulkEditMode,
    onToggle,
    selectedCount,
    totalCount,
    onSelectAll,
    onDeselectAll,
    editModal,
    disabled = false,
}) => {
    if (disabled) return null;

    const allSelected = totalCount > 0 && selectedCount === totalCount;
    const someSelected = selectedCount > 0;

    return (
        <>
            <ButtonBuilder
                label={<CheckSquare size={16} style={{ verticalAlign: 'middle' }} />}
                title={bulkEditMode ? 'Close bulk edit' : 'Bulk edit'}
                className={`${bulkEditMode ? 'btn-primary' : 'btn-outline-secondary'} m-0 py-2`}
                style={{ width: '40px', padding: 0 }}
                useSpinner={false}
                onClick={onToggle}
            />
            {bulkEditMode ? (
                <div className='d-flex align-items-center' style={{ border: '1px solid #ced4da', borderRadius: 4, overflow: 'hidden', height: '38px' }}>
                    <label className='d-flex align-items-center m-0 px-2'
                        style={{ cursor: 'pointer', gap: 6, height: '100%' }}
                        title={someSelected ? 'Deselect all' : 'Select all'}>
                        <input type='checkbox'
                            className='form-check-input checkbox-secondary m-0'
                            ref={el => { if (el) el.indeterminate = someSelected && !allSelected; }}
                            checked={allSelected}
                            onChange={() => someSelected ? onDeselectAll() : onSelectAll()}
                        />
                        <span style={{ fontSize: 13, whiteSpace: 'nowrap' }}>{selectedCount} selected</span>
                    </label>
                    {editModal}
                </div>
            ) : null}
        </>
    );
};

export default BulkEditControls;
